export default "__VITE_ASSET__Bl4vAhpJ__"